var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layoutComponent,{tag:"component"},[_c('router-view')],1),_c('payjp-checkout',{staticClass:"wrap-payment-btn d-none",attrs:{"api-key":_vm.payjpKey,"text":"ポップアップを開く","submit-text":"このカードを登録する","name-placeholder":"JOHN DOE"},on:{"created":_vm.onTokenCreated,"failed":_vm.onTokenFailed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }